import "./styles/default.scss";
import featureAttribution from "../../../../utils/featureAttr";
import { useSelector } from "react-redux";
import LinkWrap from "../../../../components/LinkWrap/component";
import { withSuspensefulErrorBoundary } from "../../../../components/SuspensefulErrorBoundary/component";

const Breadcrumbs = ({ renderLabel }) => {
    const path = useSelector((state) => state.app.path);
    const departments = useSelector(
        (state) => state.detail?.content?.departments
    );

    if (!departments || !/sports\/olympics\/(summer|winter)/.test(path))
        return renderLabel();

    // Currently, the department data from the new ContentItem.categories field is not in hierarchal order,
    // so we use the actual path for the current instead to build the breadcrumb urls.
    const pathSegments = path.split("/");

    // For /sports/olympics/*, the ContentItem.categories[].name field which presumably would be used for
    // the breadcrumb text doesn't always match the text for the breadcrumbs currently in production. E.g. for the
    // breadcrumb representing /sports/olympic/winter, the text in production is "Winter Sports", but the name field
    // coming from GQL is "Olympics Winter". To match the breadcrumbs in production, we will use categories[].path for
    // the most nested category as each segment of the path does match the breadcrumb text in production.

    const pathFromMostNestedCategory = departments.reduce(
        (pathFromCategory, category) => {
            if (category.path.length > pathFromCategory.length)
                return category.path;
            return pathFromCategory;
        },
        ""
    );

    const categoryPathSegments = pathFromMostNestedCategory.split("/");

    const breadcrumbs = categoryPathSegments.map((text, i) => ({
        url: `/${pathSegments.slice(0, i + 1).join("/")}`,
        text,
    }));

    return (
        <>
            <ul className="breadcrumbs" data-testid="breadcrumbs">
                {breadcrumbs.map((breadcrumb) => (
                    <li key={breadcrumb.text}>
                        <LinkWrap
                            {...featureAttribution({
                                position: null,
                                name: "link",
                                instance: "breadcrumb",
                            })}
                            url={breadcrumb.url}
                        >
                            {breadcrumb.text}
                        </LinkWrap>
                    </li>
                ))}
            </ul>
            <span className="breadcrumb-flags">
                {renderLabel({ insideBreadcrumbs: true })}
            </span>
        </>
    );
};

const SafeBreadcrumbs = withSuspensefulErrorBoundary(Breadcrumbs);

export default SafeBreadcrumbs;
